import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../styles/csr.css';

const RequirementForm = ({ onSubmit }) => {
    const [selectedOption, setSelectedOption] = useState('');
    const [formData, setFormData] = useState({});

    // Handle the selection of the option
    const handleOptionChange = (event) => {
        const selected = event.target.value;
        setSelectedOption(selected);

        // Set default values for each category
        let defaults = {};

        switch (selected) {
            case 'RAM':
                defaults = {
                    min: '',
                    max: ''
                };
                break;
            case 'Disk':
                defaults = {
                    minPercentFree: '',
                    maxPercentFree: ''
                };
                break;
            case 'Internet':
                defaults = {
                    minDownload: '',
                    minUpload: '',
                    maxPing: ''
                };
                break;
            default:
                break;
        }

        setFormData(defaults); // Reset with defaults
    };

    // Handle dynamic input change
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    // Submit the form
    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSubmit) {
            onSubmit({ category: selectedOption, ...formData });
        }
        // Reset form data for selected category after submit
        handleOptionChange({ target: { value: selectedOption } });
    };

    // Render form based on selected option
    const renderFormFields = () => {
        switch (selectedOption) {
            case 'RAM':
                return (
                    <>
                        <label>Min RAM</label>
                        <input
                            type="number"
                            name="min"
                            value={formData.min || ''}
                            placeholder="Enter min RAM size e.g. 4"
                            onChange={handleInputChange}
                        />

                        <label>Max RAM</label>
                        <input
                            type="number"
                            name="max"
                            value={formData.max || ''}
                            placeholder="Enter max RAM size e.g. 16"
                            onChange={handleInputChange}
                        />
                    </>
                );

            case 'Disk':
                return (
                    <>
                        <label>Min Free Percentage</label>
                        <input
                            type="number"
                            name="minPercentFree"
                            value={formData.minPercentFree || ''}
                            placeholder="Enter min free disk space % e.g. 10"
                            onChange={handleInputChange}
                        />

                        <label>Max Free Percentage</label>
                        <input
                            type="number"
                            name="maxPercentFree"
                            value={formData.maxPercentFree || ''}
                            placeholder="Enter max free disk space % e.g. 30"
                            onChange={handleInputChange}
                        />
                    </>
                );

            case 'Internet':
                return (
                    <>
                        <label>Minimum Download Speed (Mbps)</label>
                        <input
                            type="number"
                            name="minDownload"
                            value={formData.minDownload || ''}
                            placeholder="e.g. 50"
                            onChange={handleInputChange}
                        />

                        <label>Minimum Upload Speed (Mbps)</label>
                        <input
                            type="number"
                            name="minUpload"
                            value={formData.minUpload || ''}
                            placeholder="e.g. 20"
                            onChange={handleInputChange}
                        />

                        <label>Maximum Ping (ms)</label>
                        <input
                            type="number"
                            name="maxPing"
                            value={formData.maxPing || ''}
                            placeholder="e.g. 100"
                            onChange={handleInputChange}
                        />
                    </>
                );

            default:
                return null;
        }
    };

    return (
        <div className="requirement-form">
            <h2>Enter System Requirements</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Select Category</label>
                    <select
                        onChange={handleOptionChange}
                        value={selectedOption}>
                        <option value="">Select...</option>
                        <option value="RAM">RAM</option>
                        <option value="Disk">Disk</option>
                        <option value="Internet">Internet</option>
                    </select>
                </div>

                {renderFormFields()}

                {selectedOption && (
                    <button className="submit" type="submit">
                        Submit
                    </button>
                )}
            </form>
        </div>
    );
};
// Add prop types validation
RequirementForm.propTypes = {
    onSubmit: PropTypes.func.isRequired // Ensures that onSubmit is passed as a function
};

export default RequirementForm;
